import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from '../helpers/utils.helpers';

@Pipe({
  name: 'empty',
})
export class EmptyPipe implements PipeTransform {
  transform(value: any, ...args: any[]): boolean {
    return isEmpty(value);
  }
}
